import { Navigate, useParams } from "react-router-dom";
import PersonalInfoView from "../../components/UsedComp/PersonalInfoView";
import ExamResults from "./ExamResults";
import HealthInfomationView from "./HealthInfomationView";
import { getAge } from "../../utils/age";
import Loading from "../Loading";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Modal from "../../components/Modals/Modal";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";
import HealthInfomation from "./HealthInfomation";
import MedicalRecord from "./MedicalRecord";
import { LaboratoryTable } from "../../components/Tables";
import toast from "react-hot-toast";
import {
  deleteEstudio,
  getAllEstudiosByPatient,
  getEstudiosByPatientId,
} from "../../redux/features/estudiosSlice";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import OrdenPdf from "../../pdf/OrdenPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { usePatient } from "../../customHooks/queries/usePatient";

import { HiOutlineCalendarDays } from "react-icons/hi2";
import { FaFileDownload, FaTooth } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import NewMedicalRecode from "./NewMedicalRecode";
import {
  getAllVisitas,
  getByOdontogramaPatient,
  getOdontograma,
  getVisita,
  getVisitas,
} from "../../redux/features/visitasSlice";
import { getCitas } from "../../redux/features/citasSlice";
import axios from "axios";
import { apiUrl } from "../../redux/apiUrl";

const PatientView360 = ({ setActiveTab }) => {
  const [openPatientInfo, setOpenPatientInfo] = useState(false);
  const [openPatientHealt, setOpenPatientHealt] = useState(false);
  const [openPatientCitas, setOpenPatientCitas] = useState(false);
  const [openPatientHistory, setOpenPatientHistory] = useState(false);
  const [openPatientOdontogram, setOpenPatientOdontogram] = useState(false);
  const [openPatientPanoramic, setOpenPatientPanoramic] = useState(false);
  const [antecedents, setAntecedents] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [datas, setDatas] = useState({});

  const { id } = useParams();
  const dispatch = useDispatch();
  const { data: patient, isLoading } = usePatient(id);
  const visitas = useSelector(getAllVisitas);
  const citas = useSelector(getAllVisitas);

  const citaActual = useSelector(getOdontograma);

  const estudios = useSelector(getAllEstudiosByPatient);

  const handleOdontogram = () => {
    const citas_sin_re = citas?.filter(
      (cita) => cita.cita.tipo_evento !== "Re Consulta"
    );
    setDatas(citas_sin_re[0]);
    setOpenPatientOdontogram(true);
  };

  const handleRedirect = () => {
    // window.location.href = "https://victoryabeta.rocazit.com/appointments";
    window.location.href = "/appointments";
  };

  // Obtiene la vista panoramica por el tipo de archivo y nombre del mismo
  const handlePanoramica = async () => {
    const { data } = await axios.get(`${apiUrl}/api/v1/antecedents/${id}`);
    if (data.archivos && data.archivos !== "") {
      const archivos_paths = data.archivos
        .split(",")
        .filter(
          (file) =>
            file.toUpperCase().includes("PNG") ||
            file.toUpperCase().includes("JPG") ||
            file.toUpperCase().includes("JPEG") ||
            file.toUpperCase().includes("WEBP")
        );
      setAntecedents(
        archivos_paths.find(
          (file) =>
            file.toUpperCase().includes("PANORAMICA") ||
            file.toUpperCase().includes("PANORÁMICA")
        )
      );
    }
    setIsOpen(true);
    setOpenPatientPanoramic(true);
  };

  // useEffect(() => {
  //   const citas_sin_re = citas?.filter((cita) => cita.cita.tipo_evento !== "Re Consulta");
  //   console.log("Citas: ", citas);
  //   console.log("Sin reconsultas: ", citas_sin_re);
  //   console.log("Paciente especificado: ", citas_sin_re[0]?.patient);
  // },[citas, datas]);

  // const fetchVisitas = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/api/v1/visitas/patient/${id}`);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching visitas:", error);
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   const obtenerVisitas = async () => {
  //     const visitas = await fetchVisitas();
  //     if (visitas) {
  //       dispatch(getEstudiosByPatientId( id ));
  //     }
  //   };
  //   dispatch(getCitas());
  //   obtenerVisitas();
  // }, [id, dispatch]);

  useEffect(() => {
    dispatch(getVisitas(id));
    dispatch(getEstudiosByPatientId(id));
    dispatch(getByOdontogramaPatient(id));
  }, [id]);

  if (isLoading) return <Loading />;

  return (
    <>
      {isOpen && (
        <Modal
          closeModal={() => {
            setIsOpen(false);
            setDatas({});
            setOpenPatientPanoramic(false);
          }}
          isOpen={isOpen}
          title="Radiografía panorámica"
        >
          {openPatientPanoramic && (
            <div className="flex justify-center">
              {antecedents !== "" ? (
                <img
                  src={
                    antecedents
                    // "https://clinicadentalelmaiten.cl/wp-content/uploads/2023/05/1-1-768x576.jpg"
                  }
                  alt=""
                  /*             width={500}
                height={500} */
                />
              ) : (
                "Debe adjuntar una vista panoramica antes"
              )}
            </div>
          )}
        </Modal>
      )}

      {openPatientOdontogram && (
        <Modal
          closeModal={() => {
            setIsOpen(false);
            setDatas({});
            setOpenPatientOdontogram(false);
            dispatch(getEstudiosByPatientId(id));
          }}
          isOpen={openPatientOdontogram}
          title="Odontograma"
        >
          {datas ? (
            <NewMedicalRecode
              cita={{
                patient: citas?.find((cita) => cita.cita_id === datas?.cita?.id)
                  ?.patient,
                ...datas?.cita,
              }}
              defaultTab={3}
            />
          ) : (
            <div className="flex justify-center items-center flex-col flex-wrap">
              <p>Debe agendar una cita antes</p>
              <button
                className="flex justify-center bg-subMain rounded-lg text-white text-center text-2x2 mb-4 p-2 w-48 ml-2"
                onClick={() => {
                  handleRedirect();
                }}
              >
                <p className="flex flex-col items-center text-x text-center">
                  <span className="flex items-center flex-row">
                    <span className="mr-1">Agendar una cita</span>
                    <HiOutlineCalendarDays className="mx-1 self-center" />
                  </span>
                </p>
              </button>
            </div>
          )}
        </Modal>
      )}
      {!patient.data ? (
        <Loading />
      ) : (
        <div className="w-full h-[calc(100vh-8rem)] overflow-clip">
          {openPatientInfo && (
            <Modal
              isOpen={openPatientInfo}
              closeModal={() => {
                setOpenPatientInfo(false);
              }}
              title="Informacion del Paciente"
              width={"max-w-3xl"}
            >
              <PersonalInfo titles={false} operation="edit" />
            </Modal>
          )}
          {openPatientHealt && (
            <Modal
              isOpen={openPatientHealt}
              closeModal={() => {
                setOpenPatientHealt(false);
              }}
              title="Antecedentes Personales"
              width={"max-w-3xl"}
            >
              <HealthInfomation />
            </Modal>
          )}
          {
            <Modal
              isOpen={openPatientCitas}
              closeModal={() => {
                setOpenPatientCitas(false);
              }}
              title="Imagenologia y Laboratorios"
            >
              <LaboratoryTable
                id={id}
                data={estudios}
                functions={{
                  delete: (body) => {
                    ConfirmationAlert({
                      title: "Eliminar Orden",
                      text: "Esta seguro de eliminar la orden?",
                      onAccept: async () => {
                        const res = await dispatch(deleteEstudio(body));
                        if (res?.error) {
                          toast.error(
                            "No se pudo eliminar la orden, " + res.error
                          );
                        } else {
                          dispatch(getEstudiosByPatientId(id));
                          toast.success("Orden eliminada correctamente!");
                        }
                      },
                    });
                  },
                  printPdf: async (body) => {
                    const blob = await pdf(
                      <OrdenPdf
                        data={{
                          nombre: `${visitas[0]?.patient?.persona?.nombre} ${visitas[0]?.patient?.persona?.apellidos}`,
                          edad: `${
                            visitas[0]?.patient?.persona?.fecha_nacimiento
                              ? getAge(
                                  new Date(
                                    visitas[0]?.patient?.persona?.fecha_nacimiento
                                  )
                                ) + " años"
                              : ""
                          }`,
                          fecha: new Date().toLocaleDateString("en-GB"),
                          lugarAtencion: visitas[0]?.visita?.lugar_atencion,
                          seguro: `${visitas[0]?.patient?.empresa_seg ?? ""}`,
                          orden: body,
                        }}
                      />
                    ).toBlob();
                    saveAs(
                      blob,
                      `Orden-${`${visitas[0]?.patient?.persona?.nombre}-${visitas[0]?.patient?.persona?.apellidos}`}-${new Date().toLocaleDateString(
                        "en-GB"
                      )}.pdf`
                    );
                  },
                }}
                button={true}
                viewString={"360"}
                patient={patient}
              />
            </Modal>
          }
          {
            <Modal
              isOpen={openPatientHistory}
              closeModal={() => {
                setOpenPatientHistory(false);
              }}
              title="Historial Medico"
              width={"max-w-3xl"}
            >
              {
                // citas && citas?.length > 0 ?
                <MedicalRecord />
                // :
                // <div className="flex justify-center items-center flex-col flex-wrap">
                //   <p>
                //     Debe agendar una cita antes
                //   </p>
                //   <button
                //     className="flex justify-center bg-subMain rounded-lg text-white text-center text-2x2 mb-4 p-2 w-48 ml-2"
                //     onClick={() => {
                //       handleRedirect();
                //     }}
                //   >
                //     <p className="flex flex-col items-center text-xs text-center">
                //       <span className="flex items-center flex-row">
                //         <span className="mr-1">Agendar una cita</span>
                //         <HiOutlineCalendarDays className="mx-1 self-center" />
                //       </span>
                //     </p>
                //   </button>
                // </div>
              }
            </Modal>
          }
          <div className="sm:grid sm:grid-cols-12 sm:grid-rows-3 gap-1 overflow-auto sm:overflow-hidden h-full w-full ">
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="100"
              data-aos-offset="200"
              className="flex justify-center col-span-12 sm:col-span-3 row-span-3 sm:row-span-1 bg-white rounded-xl border-[1px] border-border p-6 overflow-hidden"
            >
              <div
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="100"
                data-aos-offset="200"
                className="col-span-12 flex-colo gap-6 lg:col-span-4 bg-white lg:sticky top-28"
              >
                <img
                  src={
                    patient.data.persona?.perfil ??
                    "https://png.pngtree.com/png-vector/20230131/ourmid/pngtree-flat-user-profile-icon-on-isolated-background-with-permission-sign-vector-png-image_49602760.jpg"
                  }
                  alt="imagen de perfil"
                  className="w-20 h-20 rounded-full object-cover border border-dashed border-subMain"
                />
                <div className="gap-2 flex-colo">
                  <h2 className="text-xs font-semibold">{`${patient.data?.persona?.nombre} ${patient.data?.persona?.apellidos}`}</h2>
                  <a
                    href={`mailto:${patient.data?.persona?.email}`}
                    className="text-xs text-textGray"
                  >
                    {patient.data?.persona?.email}
                  </a>
                  <a
                    href={`https://wa.me/+571${patient.data?.persona?.telf1}/`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs"
                  >
                    {patient.data?.persona?.telf1}
                  </a>
                  <p className="text-xs text-subMain bg-text font-medium py-1 px-4 rounded-full border-[0.5px] border-subMain">
                    {getAge(new Date(patient.data.persona?.fecha_nacimiento))}{" "}
                    años
                  </p>
                </div>
              </div>
            </div>
            <div className="sm:col-span-9 sm:row-span-1 sm:col-start-4 p-5 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <h2 className=" font-semibold text-base">Informacion Personal</h2>
              <div className="h-5/6 overflow-y-scroll">
                <PersonalInfoView />
              </div>
              <p
                onClick={() => setOpenPatientInfo(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>
            <div className="border sm:col-span-3 sm:row-span-1 sm:row-start-2 flex flex-col justify-between p-5 pb-0 rounded-lg overflow-hidden bg-white">
              <h2 className="pb-2 font-semibold text-base">
                Antecedentes Personales
              </h2>
              <div className="h-5/6 overflow-y-scroll">
                <HealthInfomationView />
              </div>
              <p
                onClick={() => setOpenPatientHealt(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>

            {/* nuevo */}
            <div className="border sm:col-span-3 sm:row-span-1 sm:row-start-2 flex flex-col justify-between p-5 pb-0 rounded-lg overflow-hidden bg-white">
              <h2 className="pb-2 font-semibold text-base">Examen Intraoral</h2>
              <div className="flex justify-center flex-row flex-wrap">
                <button
                  className="flex justify-center bg-subMain rounded-lg text-white text-center text-2xl mb-4 p-2 w-44 ml-2"
                  onClick={() => {
                    handlePanoramica();
                  }}
                >
                  <p className="text-xs"> Panorámica </p>
                </button>
              </div>
              <div className="flex justify-center flex-row flex-wrap">
                <button
                  className="flex justify-center bg-subMain rounded-lg text-white text-center text-2xl mb-4 p-2 w-44 ml-2"
                  onClick={() => {
                    handleOdontogram();
                  }}
                >
                  <p className="flex flex-col items-center text-xs text-center">
                    <span className="flex items-center flex-row">
                      <span className="mr-1">Odontograma</span>
                      <FaTooth className="mx-1 self-center" />
                    </span>
                  </p>
                </button>
              </div>
            </div>

            <div className="sm:col-span-6 sm:row-span-1 sm:col-start-7 p-5 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <h2 className="font-semibold text-base">
                Imagenologia y Laboratorios
              </h2>
              <div className="h-2/3 overflow-y-scroll">
                <LaboratoryTable data={estudios} button={true} view={true} />
              </div>
              <p
                onClick={() => setOpenPatientCitas(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>

            <div className="sm:col-span-12 sm:row-span-1 sm:row-start-3 flex flex-col justify-between p-5 pb-0 border rounded-lg bg-white">
              <h2 className="font-semibold text-base">Historial Medico</h2>
              <div className="pt-0 overflow-y-scroll ">
                {
                  // citas &&citas?.length > 0 ?
                  <MedicalRecord />
                  // :
                  // <div className="flex justify-center items-center flex-col flex-wrap">
                  //   <p>
                  //     Debe agendar una cita antes
                  //   </p>
                  //   <button
                  //     className="flex justify-center bg-subMain rounded-lg text-white text-center text-2x2 mb-4 p-2 w-48 ml-2"
                  //     onClick={() => {
                  //       handleRedirect();
                  //     }}
                  //   >
                  //     <p className="flex flex-col items-center text-xs text-center">
                  //       <span className="flex items-center flex-row">
                  //         <span className="mr-1">Agendar una cita</span>
                  //         <HiOutlineCalendarDays className="mx-1 self-center" />
                  //       </span>
                  //     </p>
                  //   </button>
                  // </div>
                }
              </div>
              <p
                onClick={() => setOpenPatientHistory(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PatientView360;
